import React from "react"

import PopoverMenuOption from "../../../../../../../popover-menu/popover-menu/menu-option"
import PopoverMenuHeader from "../../../../../../../popover-menu/popover-menu/popover-menu-header"
import {PopoverMenuItemType} from "../../../../../../../popover-menu/popover-menu/const"

type Props = {
    options             : Option[]

    optionClassName?    : string

    onClick             : {(value: any): void}
}

// const debug = "ToolbarColorMenu_Options"
const debug = false

export default function ToolbarColorMenu_Options(props:Props) {

    return (
        <>
            {_.map(props.options, (option:Option, index:number)=> {
                switch (option.type) {
                    case PopoverMenuItemType.SEPARATOR:
                        return <div key={index} className="separator"/>

                    case PopoverMenuItemType.HEADER:
                        return <PopoverMenuHeader key={index} title={option.title} />

                    default:
                        return <PopoverMenuOption key           = {"{0}_{1}".f(index,option.value)}
                                                  className     = {props.optionClassName}
                                                  option        = {option}
                                                  iconComponent = {option.iconComponent}
                                                  onClick       = {()=>props.onClick(option.value)}/>
                }
            })}
        </>
    )
}

ToolbarColorMenu_Options.defaultProps = {
    optionClassName: "w-160 border-box"
}